import Header from "../Header";
import SalaryTable from "./SalaryTable";
import { toast } from "react-toastify";
import { GenericPagination } from "src/components/ui/pagination";
import { useSearchParams } from "react-router-dom";
import Search from "src/components/input/Search";
import { updateSearchParams } from "src/utils";
import { Button } from "src/components/buttons/shadcn-button";
import { TrashIcon } from "lucide-react";
import { useEmployees } from "../EmployeeList/hook/useFetchEmployees";
import { useState } from "react";
import { useDebounce } from "use-debounce";

const Salary = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const page = parseInt(searchParams.get("page") || "1", 10);
  const pagesize = 25;

  const name = searchParams.get("fullname") || "";
  const employee_code = searchParams.get("employee_code") || "";

  const [debouncedName] = useDebounce(name, 500);
  const [debouncedCode] = useDebounce(employee_code, 500);

  const [failSafePageNumber, setFailSafePageNumber] = useState(1);

  const filters = {
    page,
    pagesize,
    name: debouncedName,
    employee_code: debouncedCode,
  };

  const { data: employees = [], isLoading } = useEmployees(filters);

  // pagination
  const handleNextPage = () => {
    setFailSafePageNumber(page);
    setSearchParams({
      ...Object.fromEntries(searchParams),
      page: (page + 1).toString(),
    });
  };

  const handlePrevPage = () => {
    if (page === 1) {
      toast.error("This is the first page");
      return;
    }
    setSearchParams({
      ...Object.fromEntries(searchParams),
      page: (page - 1).toString(),
    });
  };

  const handleJumpToPage = (page: number) => {
    setSearchParams({
      ...Object.fromEntries(searchParams),
      page: page.toString(),
    });
  };

  const clearAllFilters = () => {
    setSearchParams({});
  };

  return (
    <div className="mx-auto w-[85%]">
      <div className="">
        <Header title="Salary Management" href="/hr" />
      </div>
      <div className="grid grid-cols-3 gap-4 py-3">
        <Search
          value={name}
          placeholder="Search by Full Name"
          onChange={(value) =>
            updateSearchParams("email", value, setSearchParams, searchParams)
          }
          className="border-blue-200"
        />
        <Search
          value={employee_code}
          placeholder="Search by Employee Code"
          onChange={(value) =>
            updateSearchParams("name", value, setSearchParams, searchParams)
          }
          className="border-blue-200"
        />
        <div className="flex justify-end items-center pr-4">
          <Button onClick={clearAllFilters} className="hover:bg-red-200">
            <TrashIcon className="size-5" />
          </Button>
        </div>
      </div>
      <div className="mt-3 rounded-xl shadow-md shadow-slate-500 p-2 h-[75vh] overflow-y-auto">
        {isLoading ? (
          <div className="w-full h-full flex justify-center items-center">
            <span className="loading loading-dots loading-xl size-16"></span>
          </div>
        ) : (
          <SalaryTable employees={employees} />
        )}
      </div>
      <div className="flex justify-between items-center p-3 border rounded-md mt-2">
        {/* <div className="flex items-center justify-between px-3 py-2 border rounded-md">
          <label className="font-semibold">Limit</label>
          <select
            value={pagesize}
            onChange={(e) => {
              setSearchParams({
                ...Object.fromEntries(searchParams),
                pagesize: e.target.value,
              });
            }}
            className="border p-1 rounded-md ml-2"
          >
            {[10, 25].map((value) => (
              <option value={value}>{value}</option>
            ))}
          </select>
        </div> */}
        <div className="flex-grow">
          <GenericPagination
            currentPage={page}
            onNext={handleNextPage}
            onPrev={handlePrevPage}
            jumpPage={handleJumpToPage}
          />
        </div>
      </div>
    </div>
  );
};

export default Salary;
